import { css, DefaultTheme } from 'styled-components';
import { getSpacingToken, getToken, rem } from '@optimus-web/common';
import { BadgeVariant } from './types';

export const getBadgeSize = ({
    $content,
    children,
    contentLength = 0,
    outline,
    theme,
}: {
    $content?: number | string;
    children?: React.ReactChild;
    contentLength?: number;
    outline?: boolean;
    theme: DefaultTheme;
}) => {
    const large = !!$content || !!children || !!contentLength || (outline && $content);
    const size = rem({ size: getSpacingToken(large ? '200' : '150')({ theme }) });

    return css`
        min-height: ${size};
        min-width: ${size};
        line-height: ${size};
    `;
};

export const getBadgeOffset = ({ $offset }: { $offset?: number }) => {
    if ($offset) {
        return $offset;
    }

    return getSpacingToken('100');
};

export const getBadgeColors = (variant?: BadgeVariant) => {
    switch (variant) {
        case 'subtle':
            return css`
                color: ${getToken('legacyTagTextPrimary')};
                background-color: ${getToken('legacyTagBackgroundPrimary')};
            `;
        default:
            return css`
                color: ${getToken('textStaticInverse')};
                background-color: ${getToken('backgroundAccentPrimary')};
            `;
    }
};
